import React, { Component } from 'react'

export default class Weekdays extends Component {
  shouldComponentUpdate(nextProps) {
    return this.props !== nextProps
  }
  render() {
    const {
      classNames,
      firstDayOfWeek,
      showWeekNumbers,
      weekdaysLong,
      weekdaysShort,
      locale,
      localeUtils,
      weekdayElement,
    } = this.props
    const days = []
    for (let i = 0; i < 7; i += 1) {
      const weekday = (i + firstDayOfWeek) % 7
      const elementProps = {
        key: i,
        className: classNames.weekday,
        weekday,
        weekdaysLong,
        weekdaysShort,
        localeUtils,
        locale,
      }
      const element = React.isValidElement(weekdayElement)
        ? React.cloneElement(weekdayElement, elementProps)
        : React.createElement(weekdayElement, elementProps)
      days.push(element)
    }

    return (
      // biome-ignore lint/a11y/useSemanticElements: TODO
      <div className={classNames.weekdays} role="rowgroup">
        {/** biome-ignore lint/a11y/useFocusableInteractive: TODO */}
        {/** biome-ignore lint/a11y/useSemanticElements: TODO */}
        <div className={classNames.weekdaysRow} role="row">
          {showWeekNumbers && <div className={classNames.weekday} />}
          {days}
        </div>
      </div>
    )
  }
}
